const state = {
  visitedViews: [],
  cachedViews: [],
  viewsPosition: {},
  currentModule: null,
  currentView: null
}

const mutations = {
  ADD_VISITED_VIEW: (state, view) => {
    if (state.visitedViews.some(v => v.path === view.path)) return
    state.visitedViews.push(
      Object.assign({}, view, {
        title: (view.query && view.query.title) || view.meta.title || 'no-name'
      })
    )
  },
  ADD_CACHED_VIEW: (state, view) => {
    if (state.cachedViews.includes(view.name)) return
    if (!view.meta.noCache) {
      state.cachedViews.push(view.name)
    }
  },

  DEL_VISITED_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },
  DEL_CACHED_VIEW: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    const cachedViewsName = state.visitedViews.reduce((arr, view) => {
      if (view?.meta?.noCache !== undefined && !view?.meta?.noCache) {
        arr.push(view.name)
        return arr
      }
      return arr
    }, [])
    index > -1 && cachedViewsName.indexOf(view.name) == -1 && state.cachedViews.splice(index, 1)
  },

  DEL_OTHERS_VISITED_VIEWS: (state, view) => {
    state.visitedViews = state.visitedViews.filter(v => {
      return v.meta.affix || v.path === view.path
    })
  },
  DEL_OTHERS_CACHED_VIEWS: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    if (index > -1) {
      state.cachedViews = state.cachedViews.slice(index, index + 1)
    } else {
      // if index = -1, there is no cached tags
      state.cachedViews = []
    }
  },

  DEL_ALL_VISITED_VIEWS: state => {
    // keep affix tags
    const affixTags = state.visitedViews.filter(tag => tag.meta.affix)
    state.visitedViews = affixTags
  },
  DEL_ALL_CACHED_VIEWS: state => {
    state.cachedViews = []
  },

  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view)
        break
      }
    }
  },

  ADD_CACHED_POSITION: (state, data) => {
    const view = data.view
    if (view?.meta?.noCache !== undefined && !view?.meta?.noCache) {
      state.viewsPosition[view.fullPath] = {
        el: data.el,
        scrollTop: data.el.scrollTop
      }
    }
  },

  SET_CACHED_POSITION: (state, view) => {
    const target = state.viewsPosition[view.fullPath]
    if (target) {
      target.el.scrollTop = target.scrollTop
    }
  },

  DEL_CACHED_POSITION: (state, view) => {
    if (state.viewsPosition[view.fullPath]) {
      delete state.viewsPosition[view.fullPath]
    }
  },
  ADD_CURRENT_VIEW: (state, view) => {
    state.currentView = view
    state.currentModule = view.meta?.moduleCode ?? null
  }
}

const actions = {
  addView({ dispatch }, view) {
    dispatch('addVisitedView', view)
    // dispatch('addCachedView', view)
  },
  addVisitedView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view)
    commit('ADD_CURRENT_VIEW', view)
  },
  addCachedView({ commit }, view) {
    commit('ADD_CACHED_VIEW', view)
  },
  addCachedPosition({ commit }, data) {
    commit('ADD_CACHED_POSITION', data)
  },
  setCachedPosition({ commit }, view) {
    commit('SET_CACHED_POSITION', view)
  },

  delView({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view)
      dispatch('delCachedView', view)
      dispatch('delCachedPosition', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delCurrentViews({ commit, state }, params) {
    commit('DEL_VISITED_VIEW', params.view)
    const latestView = [...state.visitedViews].slice(-1)[0]
    if (latestView) {
      params.$router.push(latestView)
    } else {
      params.$router.push('/')
    }
  },
  closeCurrentView({ commit, state }, params) {
    commit('DEL_VISITED_VIEW', params.view)
    commit('DEL_CACHED_VIEW', params.view)
    if (state.visitedViews.length) {
      params.$router.go(-1)
    } else {
      params.$router.push('/')
    }
  },
  delVisitedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', view)
      resolve([...state.visitedViews])
    })
  },
  delCachedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_VIEW', view)
      resolve([...state.cachedViews])
    })
  },
  delCachedPosition({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_POSITION', view)
      resolve(view)
    })
  },

  delOthersViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delOthersVisitedViews', view)
      dispatch('delOthersCachedViews', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delOthersVisitedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_VISITED_VIEWS', view)
      resolve([...state.visitedViews])
    })
  },
  delOthersCachedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_CACHED_VIEWS', view)
      resolve([...state.cachedViews])
    })
  },

  delAllViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delAllVisitedViews', view)
      dispatch('delAllCachedViews', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delAllVisitedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_VISITED_VIEWS')
      resolve([...state.visitedViews])
    })
  },
  delAllCachedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_CACHED_VIEWS')
      resolve([...state.cachedViews])
    })
  },

  updateVisitedView({ commit }, view) {
    commit('UPDATE_VISITED_VIEW', view)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
